import * as S from './styles';
import { useRef, useState, useEffect } from 'react';

export interface Props {
  children: React.ReactNode;
}

const LazyLoadCard = ({ children }: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const [elementHeight, setElementHeight] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const productRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          if (productRef.current && !elementHeight) {
            setElementHeight(productRef.current.offsetHeight);
          }
          setIsVisible(false);
        }
      },
      {
        threshold: 0,
        rootMargin: '100px',
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [elementHeight]);

  useEffect(() => {
    if (isVisible && productRef.current && !elementHeight) {
      const height = productRef.current.offsetHeight;
      if (height > 0) {
        setElementHeight(height);
      }
    }
  }, [isVisible, elementHeight]);

  return (
    <S.ProductContainer ref={containerRef}>
      {isVisible ? (
        <div style={{ height: '100%' }} ref={productRef}>
          {children}
        </div>
      ) : (
        <div style={{ height: elementHeight || 'auto', width: '100%' }} />
      )}
    </S.ProductContainer>
  );
};

export default LazyLoadCard;
